import React from 'react';
import { Spin } from 'antd';

const style = {
  position: 'fixed',
  top: 0,
  left: 0,
  height: '100%',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: 50,
  zIndex: 10000,
};

function Loading(props) {
  return (
    <div role="status" aria-live="polite" aria-label="Loading" style={{ ...style, ...props.style }}>
      <Spin size="large" />
    </div>
  );
}

export default Loading;
